
import {
  GET_PI_STUDYLIST_DATA_SUCCESS,
  GET_PI_STUDYLIST_DATA_FAILURE,
  GET_PI_DETAILS_DATA_SUCCESS,
  GET_PI_DETAILS_DATA_FAILURE,
    GET_ZONE_DATA_SUCCESS,
    GET_ZONE_DATA_FAILURE,
    GET_STATE_DATA_SUCCESS,
    GET_STATE_DATA_FAILURE,
    GET_CITY_DATA_SUCCESS,
    GET_CITY_DATA_FAILURE,
    GET_SITE_DATA_SUCCESS,
    GET_SITE_DATA_FAILURE,
    GET_STUDIES_DATA_FAILURE,
    GET_STUDIES_DATA_SUCCESS,
    GET_AEBANK_DATA_SUCCESS,
    GET_AEBANK_DATA_FAILURE,
    GET_AEPREVIEW_DATA_FAILURE,
    GET_AEPREVIEW_DATA_SUCCESS,
    CREATE_NEWSTUDY_DATA_SUCCESS,
    CREATE_NEWSTUDY_DATA_FAILURE,
    GET_AEDVEVENT_BYID_DATA_SUCCESS,
    GET_AEDVEVENT_BYID_DATA_FAILURE,
    CREATE_AEBANK_EVENT_DATA_SUCCESS,
    CREATE_AEBANK_EVENT_DATA_FAILURE,
    GET_EVENT_CLASSIFICATON_DATA_FAILURE,
    GET_EVENT_CLASSIFICATON_DATA_SUCCESS,
    UPDATE_EVENT_DATA_SUCCESS,
    UPDATE_EVENT_DATA_FAILURE,
    GET_DOSE_ADMINISTRATION,
    GET_DOSE_ADMINISTRATION_FAILURE,
    GET_SITE_ADMINISTRATION,
    GET_SITE_ADMINISTRATION_FAILURE,
    GET_STUDY_DATA_SUCCESS,
    GET_STUDY_DATA_FAILURE,
    LOGIN_DATA_SUCCESS,
    LOGIN_DATA_FAILURE,
    GET_SERIOUS_ADV_EVENT_SUCCESS,
    GET_SERIOUS_ADV_EVENT_FAILURE,
    GET_STUDY_TITLES_FAILURE,
    GET_STUDY_TITLES_SUCCESS,
    GET_SUBJECT_NUMBER_FAILURE,
    GET_SUBJECT_NUMBER_SUCCESS,
    GET_ALL_CAUSALITIES_FAILURE,
    GET_ALL_CAUSALITIES_SUCCESS,
    GET_STUDY_AE_DETAILS_SUCCESS,
    GET_STUDY_AE_DETAILS_FAILURE,
    GET_ALL_OUTCOME_SUCCESS,
    GET_ALL_OUTCOME_FAILURE,
    GET_ACTION_TAKEN_FAILURE,
    GET_ACTION_TAKEN_SUCCESS,
    GET_SUBJECT_LIST,
    GET_SUBJECT_LIST_FAILURE,
    GET_SUBJECT_COUNTS,
    GET_SUBJECT_COUNTS_FAILURE,
    GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE,
    GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS,
    GET_SUBJECT_PROFILE_DETAILS_SUCCESS,
    GET_SUBJECT_PROFILE_DETAILS_FAILURE,
    GET_STUDY_INFO,
    GET_PIDASHBOARD_CHART_DATA,
    GET_PIDASHBOARD_CHART_DATA_FAILURE,
    ADD_NEW_ADVERSE_EVENT_FAILURE,
    ADD_NEW_ADVERSE_EVENT_SUCCESS,
    GET_ZONE_COUNTS_DATA,
    GET_ZONE_COUNTS_DATA_FAILURE,
    GET_MARKETING_HEAD_DATA,
    GET_MARKETING_HEAD_DATA_FAILURE,
    GET_ALL_SUBJECTS_CURRENT_DOSE_FAILURE,
    GET_ALL_SUBJECTS_CURRENT_DOSE_SUCCESS,
    GET_ALL_SUBJECTS_TO_ADD_AE_SUCCESS,
    GET_PI_LIST_DATA_SUCCESS,
    GET_PI_LIST_DATA_FAILURE,
    GET_QR_STUDYLIST_DATA_SUCCESS,
    GET_QR_STUDIES_DATA_FAILURE,
    GET_QRSUBJECT_COUNTS_SUCCESS,
    GET_QRSUBJECT_COUNTS_FAILURE,
    GET_QRSUBJECT_LIST_SUCCESS,
    GET_QRSUBJECT_LIST_FAILURE,
    GET_QR_STUDYLIST_DATA_FAILURE,
    GET_QR_LIST_DATA_SUCCESS,
    GET_QR_LIST_DATA_FAILURE,
    GET_MR_LIST_DATA_SUCCESS,
    GET_MR_LIST_DATA_FAILURE,
    GET_MR_LIST_STUDIES_DATA_SUCCESS,
    GET_MR_LIST_STUDIES_DATA_FAILURE,
    GET_QR_LIST_STUDIES_DATA_SUCCESS,
    GET_QR_LIST_STUDIES_DATA_FAILURE,
    GET_PI_LIST_STUDIES_DATA_SUCCESS,
    GET_PI_LIST_STUDIES_DATA_FAILURE,
    GET_PI_LIST_SITES_DATA_SUCCESS,
    GET_PI_LIST_SITES_DATA_FAILURE,
    GET_QRDASHBOARD_LIST_SUCCESS,
    GET_QRDASHBOARD_LIST_FAILURE,
    GET_SUBJECT_DETAILS_FAILURE,
    GET_SUBJECT_DETAILS_SUCCESS,
    GET_EVENT_DETAILS_FAILURE,
    GET_EVENT_DETAILS_SUCCESS,
    GET_QR_STUDY_INFO_FAILURE,
    GET_QR_STUDY_INFO,
    GET_MR_STUDY_INFO,
    GET_MR_STUDY_INFO_FAILURE,
    GET_ACTION_TAKEN_FOR_AE_FAILURE,
    GET_ACTION_TAKEN_FOR_AE_SUCCESS,
    GET_MARKETING_HEAD_STUDY_DATA,
    GET_MARKETING_HEAD_STUDY_DATA_FAILURE,
    GET_MARKETING_HEAD_STUDY_SITES_DATA,
    GET_MARKETING_HEAD_STUDY_SITES_DATA_FAILURE,
    GET_MARKETING_STAFF_LIST,
    GET_MARKETING_STAFF_LIST_FAILURE,
    GET_REJECTED_EVENTS_LIST,
    GET_REJECTED_EVENTS_LIST_FAILURE,
    GET_REVIRWER_COMMENTS,
    GET_REVIRWER_COMMENTS_FAILURE,
    GET_MS_DROPDOWNS,
    GET_MS_DROPDOWNS_FAILURE,
    GET_MS_SITES_DROPDOWNS,
    GET_MS_SITES_DROPDOWNS_FAILURE,
    GET_MS_SUBJECT_COUNTS,
    GET_MS_SUBJECT_COUNTS_FAILURE,
    GET_MS_SUBJECT_LIST,
    GET_MS_SUBJECT_LIST_FAILURE,
    RESET_EVENT_DETAILS,
    RESET_AE_STEPPER_DATA,
    RESET_SUBJECT_PROFILE,
    GET_MSSUBJECT_DB_COUNTS_SUCCESS,
    GET_MSSUBJECT_DB_COUNTS_FAILURE,
    GET_ALL_MEDDRA_CLASSIFICATION_SUCCESS,
    GET_ALL_MEDDRA_CLASSIFICATION_FAILURE,
    GET_ALL_WHODD_CLASSIFICATION_SUCCESS,
    GET_ALL_WHODD_CLASSIFICATION_FAILURE,
    GET_ALL_WHODD_CLASSIFICATION_SUCCESS_1,
    GET_ALL_WHODD_CLASSIFICATION_FAILURE_1,
    
    GET_MR_STUDYLIST_DATA_SUCCESS,
    GET_MR_STUDYLIST_DATA_FAILURE,
    GET_MR_DB_COUNTS,
    GET_MR_DB_COUNTS_FAILURE,
    GET_MRSUBJECT_LIST_SUCCESS,
    GET_MRSUBJECT_LIST_FAILURE,
    GET_MRSUBJECT_COUNTS_SUCCESS,
    GET_MRSUBJECT_COUNTS_FAILURE,
    GET_PMSSUBJECT_COUNTS_SUCCESS,
    GET_PMSSUBJECT_COUNTS_FAILURE,
    GET_PMSDASHBOARD_CHART_DATA__SUCCESS,
    GET_PMSDASHBOARD_CHART_DATA_FAILURE,
    GET_PMSSTUDY_DATA_SUCCESS,
    GET_PMSSTUDY_DATA_FAILURE,
    GET_PMS_STUDY_INFO,
    GET_PMSSUBJECT_LIST,
    GET_PMSSUBJECT_LIST_FAILURE,
    GET_PMSSUBJECTDASHBOARD_COUNTS_SUCCESS,
    GET_PMSSUBJECTDASHBOARD_COUNTS_FAILURE,
    GET_QRSUBJECT_REVIEW_LIST_SUCCESS,
    GET_QRSUBJECT_REVIEW_LIST_FAILURE,
    GET_QRSUBJECTS_RELATED_COUNTS_FAILURE,
    GET_QRSUBJECTS_RELATED_COUNTS_SUCCESS,
    GET_SUBJECT_INFORMATION_FAILURE,
    GET_SUBJECT_INFORMATION_SUCCESS,
    GET_MH_STUDIES_SUCCESS,
    GET_MH_STUDIES_FAILURE,
    GET_MHDB_COUNTS_SUCCESS,
    GET_MHDB_COUNTS_FAILURE,
    GET_MH_SUBJECT_LIST,
    GET_MH_SUBJECT_LIST_FAILURE,
    GET_MH_SUBJECT_LIST_COUNTS,
    GET_MH_SUBJECT_LIST_COUNTS_FAILURE,
    GET_PI_REJ_SUBJECTS_SUCCESS,
    GET_PI_REJ_SUBJECTS_FAILURE,
    GET_REJ_SUBJ_DETAILS_SUCCESS,
    GET_REJ_SUBJ_DETAILS_FAILURE,
    GET_PMSSUBJECT_DETAILS_SUCCESS,
    GET_PMSSUBJECT_DETAILS_FAILURE,
    GET_PMSEVENTSUBJECT_LIST_FAILURE,
    GET_PMSEVENTSUBJECT_LIST_SUCCESS,
    GET_PMSEVENT_COMMENTS_SUCCESS,
    GET_PMSEVENT_COMMENTS_FAILURE,
    GET_PMSADVERSE_EVENTS_OF_SUBJECT_SUCCESS,
    GET_PMSADVERSE_EVENTS_OF_SUBJECT_FAILURE,
    GET_SITES_MH_DATA_SUCCESS,
    GET_SITES_MH_DATA_FAILURE,
    GET_PMS_NOTIFICATIONS_SUCCESS,
    GET_PMS_NOTIFICATIONS_FAILURE,
    GET_REVIEW_SUBJECT_DETAILS_FAILURE,
    GET_REVIEW_SUBJECT_DETAILS_SUCCESS,
    GET_ALL_SITES_SUCCESS,
    GET_STUDY_ACTIVE_SUCCESS,
    GET_STUDY_ACTIVE_FAILURE,
    GET_PMS_REPORTS_DATA_SUCCESS,
    GET_PMS_REPORTS_DATA_FAILTURE,
    GET_NEWPMSSTUDY_DATA_SUCCESS,
    GET_NEWPMSSTUDY_DATA_FAILURE,
    GET_EVENT_FLAG,
    GET_CHANGELOGGER_SUCCESS,
    GET_CHANGELOGGER_FAILURE,
    GET_AUTDITLOGGER_SUCCESS,
    GET_AUTDITLOGGER_FAILURE,
    GET_CONCLUDED_DATA_SUCCESS,
    GET_CONCLUDED_DATA_FAILURE

  } from '../actions/actions';

  const initialState = {
    loginData: null,
    piStudyList: null,
    getSubjNum: null,
    getStudyAeDtls: null,
    actionTaken: null,
    getOutComes: null,
    getCausalities: null,
    getSAEvents: null,
    getStdyTitls: null,
    piDetails: null,
    data: null,
    error: null,
    stateData:null,
    stateError:null,
    getAeOfSubj:null,
    getSubProf:null,
    getRole_code:null,
    getEventFlag:null,
    createStudy:null,
    cityData:null,
    cityError:null,
    siteError:null,
    siteData:null,
    getStudiesError:null,
    getStudiesData:null,
    allAeEventsData:null,
    allAeEventsError:null,
    radioValue: null,
    allAEPreview:null,
    createNewStudy:null,
    getAdvEventbyId:null,
    getAdvEventbyIdError:null,
    createNewEvent:null,
    getAllClassifications:null,
    updateEvent:null,
    studyData:null,
    addNewEvent:null,
    studyError:null,
    currentDose:null,
    addNewAe:null,
    doseAdministration:null,
    doseAdministrationError:null,
    siteAdministration:null,
    siteAdministrationError:null,
    subjectList:null,
    subjectListError:null,
    subjectCounts: null,
    subjectCountsError:null,
    actionTakenforAe:null,
    studyInfo:null,
    piDashboardChartData:null,
    subjDtls:null,
    eventDtls:null,
    zoneCounts:null,
    marketingHeadsList:null,
    piList:null,
    getAllSites:null,
    getMrStudy:null,
    qrStudyList:null,
    qrSubjectcounts:null,
    qrSubjectsRelatedcounts:null,
    qrSubjectList:null,
    qrSubjectReviewList:null,
    qrSubjectInfoList:null,
    qrList:null,
    mrList:null,
    mrListStudies:null,
    qrListStudies: null,
    piListStudies: null,
    piListSites: null,
    mhStudies:null,
    mhStudiesSites:null,
    qrDashboardList:null,
    mhfStates:null,
    mhfCities: null,
    mhfSites: null,
    mhfStudies: null,
    marketingStaffList: null,
    fsiteList: null,
    fstudyList: null,
    rejectedEventsList: null,
    reviewerComments: null,
    marketingHeadListZones: null,
    marketingHeadListStudies: null,
    msdropdowns: null,
    mssitesdropdown: null,
    mssubjectcounts: null,
    mssubjectlist: null,
    msdbcounts:null,
    medraList : null,
    whoddList:null,
    whoddListNew:null,
    piRejSubj:null,
    mrStudyList:null,
    mrdbcounts:null,
    mrSubjectList: null,
    revSubjDtls: null,
    mrSubjectcounts: null,
    mhMainStudies: null,
    mhdbcounts: null,
    mhSubjectList: null,
    mhsubjectlistcounts: null,
    pmsSubjectcounts:null,
    pmsDashboardChartData:null,
    getPmsStudy:null,
    pmsSubjectList:null,
    pmsSubjeCtDashboardcounts:null,
    subjPmsDtls:null,
    eventPmsDtls:null,
    eventPmsComment:null,
    pmsAdverseEvent:null,
    allMHsites:null,
    pmsNotifications:null,
    studyActiveStatus:null,
    pmsReportsChartData:null,
    getNewPmsStudiesData:null,
    pmsChangeLoggerData:null,
    pmsAuditLoggerData:null,
    pmsConcludedData:null,
  };
  

  const ReduxReducer = (state = initialState, action) => {

    switch (action.type) {
      case GET_PMS_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          pmsNotifications: action.payload,
          error: null,
        };
      
      case GET_PMS_NOTIFICATIONS_FAILURE:
        return {
          ...state,
          pmsNotifications: null,
          error: action.payload,
        }
      case GET_MH_SUBJECT_LIST_COUNTS:
        return {
          ...state,
          mhsubjectlistcounts: action.payload,
          error: null,
        };
      
      case GET_MH_SUBJECT_LIST_COUNTS_FAILURE:
        return {
          ...state,
          mhsubjectlistcounts: null,
          error: action.payload,
        }
      case GET_MR_DB_COUNTS:
        return {
          ...state,
          mrdbcounts: action.payload,
          error: null,
        };
      
      case GET_MR_DB_COUNTS_FAILURE:
        return {
          ...state,
          mrdbcounts: null,
          error: action.payload,
        }
        case GET_MH_SUBJECT_LIST:
        return {
          ...state,
          mhSubjectList: action.payload,
          error: null,
        };
      
      case GET_MH_SUBJECT_LIST_FAILURE:
        return {
          ...state,
          mhSubjectList: null,
          error: action.payload,
        }
        
        case GET_MHDB_COUNTS_SUCCESS:
        return {
          ...state,
          mhdbcounts: action.payload,
          error: null,
        };
      
      case GET_MHDB_COUNTS_FAILURE:
        return {
          ...state,
          mhdbcounts: null,
          error: action.payload,
        }

        case GET_MH_STUDIES_SUCCESS:
          return {
            ...state,
            mhMainStudies: action.payload,
            error: null,
          };
        
        case GET_MH_STUDIES_FAILURE:
          return {
            ...state,
            mhMainStudies: null,
            error: action.payload,
          }
      case GET_MR_STUDYLIST_DATA_SUCCESS:
        return {
          ...state,
          mrStudyList: action.payload,
          error: null,
        };
      
      case GET_MR_STUDYLIST_DATA_FAILURE:
        return {
          ...state,
          mrStudyList: null,
          error: action.payload,
        }
     case RESET_EVENT_DETAILS:
      return {
        ...state,
        eventDtls: null, // Reset eventDtls to null
      };
      
      case RESET_AE_STEPPER_DATA:
        return {
          ...state,
          getAeOfSubj: null
        };

      case RESET_SUBJECT_PROFILE:
        return {
          ...state,
          getSubProf: null
        }
      case GET_EVENT_FLAG:
        return {
          ...state,
          getEventFlag: action.payload,
          error: null,
        };
      case GET_EVENT_FLAG:
        return {
          ...state,
          getRole_code: action.payload,
          error: null,
        };
      
        
      case GET_MS_SUBJECT_LIST:
        return {
          ...state,
          mssubjectlist: action.payload,
          error: null,
        };
      
      case GET_MS_SUBJECT_LIST_FAILURE:
        return {
          ...state,
          mssubjectlist: null,
          error: action.payload,
        }
      case GET_MS_SUBJECT_COUNTS:
        return {
          ...state,
          mssubjectcounts: action.payload,
          error: null,
        };
      
      case GET_MS_SUBJECT_COUNTS_FAILURE:
        return {
          ...state,
          mssubjectcounts: null,
          error: action.payload,
        }
      case GET_MS_SITES_DROPDOWNS:
        return {
          ...state,
          mssitesdropdown: action.payload,
          error: null,
        };
      
      case GET_MS_SITES_DROPDOWNS_FAILURE:
        return {
          ...state,
          mssitesdropdown: null,
          error: action.payload,
        }
      case GET_MS_DROPDOWNS:
        return {
          ...state,
          msdropdowns: action.payload,
          error: null,
        };
      
      case GET_MS_DROPDOWNS_FAILURE:
        return {
          ...state,
          msdropdowns: null,
          error: action.payload,
        }
      case GET_REVIRWER_COMMENTS:
        return {
          ...state,
          reviewerComments: action.payload,
          error: null,
        };
      
      case GET_REVIRWER_COMMENTS_FAILURE:
        return {
          ...state,
          reviewerComments: null,
          error: action.payload,
        }

      case GET_REJECTED_EVENTS_LIST:
        return {
          ...state,
          rejectedEventsList: action.payload,
          error: null,
        };
      
      case GET_REJECTED_EVENTS_LIST_FAILURE:
        return {
          ...state,
          rejectedEventsList: null,
          error: action.payload,
        }
      case GET_MARKETING_HEAD_STUDY_SITES_DATA:
        return {
          ...state,
          mhfStates: [...new Set(action.payload.map(item => item.state_name))],
          mhfCities: [...new Set(action.payload.map(item => item.city_name))],
          mhfSites: [...new Set(action.payload.map(item => item.site_name))],
          mhfStudies: [...new Set(action.payload.map(item => item.study_name))],
          mhStudiesSites: action.payload,
          error: null,
        };
      
      case GET_MARKETING_HEAD_STUDY_SITES_DATA_FAILURE:
        return {
          ...state,
          mhStudiesSites: null,
          error: action.payload,
        }
      case GET_MARKETING_HEAD_STUDY_DATA:
        return {
          ...state,
          mhStudies: action.payload,
          error: null,
        };
      
      case GET_MARKETING_HEAD_STUDY_DATA_FAILURE:
        return {
          ...state,
          mhStudies: null,
          error: action.payload,
        }
        case GET_MARKETING_STAFF_LIST:
          const uniqueSitesSet = new Set();
          const uniqueStudiesSet = new Set();

          // Iterate through the data to populate the Sets
          action.payload.forEach(item => {
            item.ms_study_site_pi.forEach(site => {
              uniqueSitesSet.add(site.site_name);
              uniqueStudiesSet.add(site.study_name);
            });
          });
          // Convert Sets to arrays and format as required
          const uniqueSitesList = [...uniqueSitesSet].map(siteName => ({
            value: siteName,
            label: siteName
          }));

          const uniqueStudiesList = [...uniqueStudiesSet].map(studyName => ({
            value: studyName,
            label: studyName
          }));
        return {
          ...state,
          fsiteList: uniqueSitesList,
          fstudyList: uniqueStudiesList,
          marketingStaffList: action.payload,
          error: null,
        };
      
      case GET_MARKETING_STAFF_LIST_FAILURE:
        return {
          ...state,
          marketingStaffList: null,
          error: action.payload,
        }
      case GET_PI_LIST_SITES_DATA_SUCCESS:
        return {
          ...state,
          piListSites: action.payload,
          error: null,
        };
      
      case GET_PI_LIST_SITES_DATA_FAILURE:
        return {
          ...state,
          piListSites: null,
          error: action.payload,
        }
      case GET_PI_LIST_STUDIES_DATA_SUCCESS:
        return {
          ...state,
          piListStudies: action.payload,
          error: null,
        };
      
      case GET_PI_LIST_STUDIES_DATA_FAILURE:
        return {
          ...state,
          piListStudies: null,
          error: action.payload,
        }
      case GET_QR_LIST_STUDIES_DATA_SUCCESS:
        return {
          ...state,
          qrListStudies: action.payload,
          error: null,
        };
      
      case GET_QR_LIST_STUDIES_DATA_FAILURE:
        return {
          ...state,
          qrListStudies: null,
          error: action.payload,
        }
      case GET_MR_LIST_STUDIES_DATA_SUCCESS:
        return {
          ...state,
          mrListStudies: action.payload,
          error: null,
        };
      
      case GET_MR_LIST_STUDIES_DATA_FAILURE:
        return {
          ...state,
          mrListStudies: null,
          error: action.payload,
        }
      case GET_PI_LIST_DATA_SUCCESS:
        return {
          ...state,
          piList: action.payload,
          error: null,
        };
      case GET_ALL_SITES_SUCCESS:
        return {
          ...state,
          getAllSites: action.payload,
          error: null,
        };
      
      case GET_PI_LIST_DATA_FAILURE:
        return {
          ...state,
          piList: null,
          error: action.payload,
        }
        case GET_QR_LIST_DATA_SUCCESS:
        return {
          ...state,
          qrList: action.payload,
          error: null,
        };
      
      case GET_QR_LIST_DATA_FAILURE:
        return {
          ...state,
          qrList: null,
          error: action.payload,
        }

        case GET_MR_LIST_DATA_SUCCESS:
        return {
          ...state,
          mrList: action.payload,
          error: null,
        };
      
      case GET_MR_LIST_DATA_FAILURE:
        return {
          ...state,
          mrList: null,
        };
      case GET_EVENT_DETAILS_SUCCESS:
        return {
          ...state,
          eventDtls: action.payload,
          error: null,
        };
      
      case GET_EVENT_DETAILS_FAILURE:
        return {
          ...state,
          eventDtls: null,
          error: action.payload,
        }
      case GET_SUBJECT_DETAILS_SUCCESS:
        return {
          ...state,
          subjDtls: action.payload,
          error: null,
        };
      
      case GET_SUBJECT_DETAILS_FAILURE:
        return {
          ...state,
          subjDtls: null,
          error: action.payload,
        }
        case GET_ALL_SUBJECTS_TO_ADD_AE_SUCCESS:
          return {
            ...state,
            addNewAe: action.payload,
            error: null,
          };
        
      case GET_ALL_SUBJECTS_CURRENT_DOSE_SUCCESS:
        return {
          ...state,
          currentDose: action.payload,
          error: null,
        };
      
      case GET_ALL_SUBJECTS_CURRENT_DOSE_FAILURE:
        return {
          ...state,
          currentDose: null,
          error: action.payload,
        }
      case ADD_NEW_ADVERSE_EVENT_SUCCESS:
        return {
          ...state,
          addNewEvent: action.payload,
          error: null,
        };
      
      case ADD_NEW_ADVERSE_EVENT_FAILURE:
        return {
          ...state,
          addNewEvent: null,
          error: action.payload,
        }
      case GET_ZONE_COUNTS_DATA:
        return {
          ...state,
          zoneCounts: action.payload,
          error: null,
        };
      
      case GET_ZONE_COUNTS_DATA_FAILURE:
        return {
          ...state,
          zoneCounts: null,
          error: action.payload,
        }

        case GET_MARKETING_HEAD_DATA:

        //   const zoneIDListWithLabel = action.payload?.map(jsonObj => ({
        //     value: jsonObj.zone_name,
        //     label: jsonObj.zone_name
        //   }));
        // const uniqueZoneIDsSet = new Set(zoneIDListWithLabel.map(obj => obj.value));
        // const uniqueZoneIDsList = [...uniqueZoneIDsSet].map(val => ({
        //     value: val,
        //     label: val
        // }));
        const uniqueZoneIDsSet = new Set(
          action.payload?.map(item => {
            if(item.zone_name !== null){
              return item.zone_name
            }
            return ""
          }
            
            )
      );
      const uniqueZoneIDsList = [...uniqueZoneIDsSet].map(val => ({
            value: val,
            label: val
        }));

        const uniqueStudyNamesSet = new Set(
          action.payload?.flatMap(item => item.mh_studies?.map(study => study.study_name))
      );
      const uniqueStudyNamesList = [...uniqueStudyNamesSet].map(studyName => ({
          value: studyName,
          label: studyName
      }));
        return {
          ...state,
          marketingHeadListZones: uniqueZoneIDsList,
          marketingHeadListStudies: uniqueStudyNamesList,
          marketingHeadsList: action.payload,
          error: null,
        };
      
      case GET_MARKETING_HEAD_DATA_FAILURE:
        return {
          ...state,
          marketingHeadsList: null,
          error: action.payload,
        }
      case GET_SUBJECT_PROFILE_DETAILS_SUCCESS:
        return {
          ...state,
          getSubProf: action.payload,
          error: null,
        };
      
      case GET_SUBJECT_PROFILE_DETAILS_FAILURE:
        return {
          ...state,
          getSubProf: null,
          error: action.payload,
        }
        case GET_STUDY_INFO:
          return {
            ...state,
            studyInfo: action.payload,
            error: null,
          };
          case GET_PIDASHBOARD_CHART_DATA:
            return {
              ...state,
              piDashboardChartData: action.payload,
              error: null,
            };
          
          case GET_PIDASHBOARD_CHART_DATA_FAILURE:
            return {
              ...state,
              piDashboardChartData: null,
              error: action.payload,
            }
          
      case GET_ADVERSE_EVENTS_OF_SUBJECT_SUCCESS:
        return {
          ...state,
          getAeOfSubj: action.payload,
          error: null,
        };
      
      case GET_ADVERSE_EVENTS_OF_SUBJECT_FAILURE:
        return {
          ...state,
          getAeOfSubj: null,
          error: action.payload,
        }
      case GET_SUBJECT_COUNTS:
        return {
          ...state,
          subjectCounts: action.payload,
          error: null,
        };
      
      case GET_SUBJECT_COUNTS_FAILURE:
        return {
          ...state,
          subjectCounts: null,
          error: action.payload,
        }
      case 'SET_RADIO_VALUE':
        return {
          ...state,
          radioValue: action.payload,
        };
      case GET_ACTION_TAKEN_FOR_AE_SUCCESS:
        return {
          ...state,
          actionTakenforAe: action.payload,
          error: null,
        };
      
      case GET_ACTION_TAKEN_FOR_AE_FAILURE:
        return {
          ...state,
          actionTakenforAe: action.payload,
          error: null,
        };
      case GET_ACTION_TAKEN_SUCCESS:
        return {
          ...state,
          actionTaken: action.payload,
          error: null,
        };
      
      case GET_ACTION_TAKEN_FAILURE:
        return {
          ...state,
          actionTaken: action.payload,
          error: null,
        };
      case GET_ALL_OUTCOME_SUCCESS:
        return {
          ...state,
          getOutComes: action.payload,
          error: null,
        };
      
      case GET_ALL_OUTCOME_FAILURE:
        return {
          ...state,
          getOutComes: action.payload,
          error: null,
        };
      case GET_STUDY_AE_DETAILS_SUCCESS:
        return {
          ...state,
          getStudyAeDtls: action.payload,
          error: null,
        };
      
      case GET_STUDY_AE_DETAILS_FAILURE:
        return {
          ...state,
          getStudyAeDtls: action.payload,
          error: null,
        };
      case GET_ALL_CAUSALITIES_SUCCESS:
        return {
          ...state,
          getCausalities: action.payload,
          error: null,
        };
      
      case GET_ALL_CAUSALITIES_FAILURE:
        return {
          ...state,
          getCausalities: action.payload,
          error: null,
        };
      case GET_SUBJECT_NUMBER_SUCCESS:
        return {
          ...state,
          getSubjNum: action.payload,
          error: null,
        };
      
      case GET_SUBJECT_NUMBER_FAILURE:
        return {
          ...state,
          getSubjNum: action.payload,
          error: null,
        };
        case GET_SUBJECT_LIST:
        return {
          ...state,
          subjectList: action.payload,
          error: null,
        };
      
      case GET_SUBJECT_LIST_FAILURE:
        return {
          ...state,
          subjectList: null,
          error: action.payload,
        };
      case GET_STUDY_TITLES_SUCCESS:
        return {
          ...state,
          getStdyTitls: action.payload,
          error: null,
        };
      case GET_STUDY_TITLES_FAILURE:
        return {
          ...state,
          getStdyTitls: action.payload,
          error: null,
        };

        case GET_STUDY_ACTIVE_SUCCESS :
          return{
            ...state,
            studyActiveStatus: action.payload,
            error:null,
          };
        case GET_STUDY_ACTIVE_FAILURE:
          return{
            ...state,
            studyActiveStatus:null,
            error:action.payload
          }

      case GET_SERIOUS_ADV_EVENT_SUCCESS:
        return {
          ...state,
          getSAEvents: action.payload,
          error: null,
        };
      
      case GET_SERIOUS_ADV_EVENT_FAILURE:
        return {
          ...state,
          getSAEvents: action.payload,
          error: null,
        };
      case GET_PI_DETAILS_DATA_SUCCESS:
        return {
          ...state,
          piDetails: action.payload,
          error: null,
        };
      
      case GET_PI_DETAILS_DATA_FAILURE:
        return {
          ...state,
          piDetails: action.payload,
          error: null,
        };
      case GET_PI_STUDYLIST_DATA_SUCCESS:
        return {
          ...state,
          piStudyList: action.payload,
          error: action.payload,
        };
      case GET_PI_STUDYLIST_DATA_FAILURE:
        return {
          ...state,
          piStudyList: null,
          error: action.payload,
        };
      case LOGIN_DATA_SUCCESS:
        return {
          ...state,
          loginData: action.payload,
          error: null,
        };
      case LOGIN_DATA_FAILURE:
        return {
          ...state,
          loginData: null,
          error: action.payload,
        };
      case UPDATE_EVENT_DATA_SUCCESS:
        return {
          ...state,
          updateEvent: action.payload,
          error: null,
        };
      case UPDATE_EVENT_DATA_FAILURE:
        return {
          ...state,
          updateEvent: null,
          error: action.payload,
        };
      case GET_EVENT_CLASSIFICATON_DATA_SUCCESS:
        return {
          ...state,
          getAllClassifications: action.payload,
          error: null,
        };
      case GET_EVENT_CLASSIFICATON_DATA_FAILURE:
        return {
          ...state,
          getAllClassifications: null,
          error: action.payload,
        };
      case CREATE_AEBANK_EVENT_DATA_SUCCESS:
        return {
          ...state,
          createNewEvent: action.payload,
          error: null,
        };
      case CREATE_AEBANK_EVENT_DATA_FAILURE:
        return {
          ...state,
          data: null,
          error: action.payload,
        };
      case GET_AEDVEVENT_BYID_DATA_SUCCESS:
        return {
          ...state,
          getAdvEventbyId: action.payload,
          error: null,
        };
      case GET_AEDVEVENT_BYID_DATA_FAILURE:
        return {
          ...state,
          data: null,
          error: action.payload,
        };
      case CREATE_NEWSTUDY_DATA_SUCCESS:
        return {
          ...state,
          createStudy: action.payload,
          error: null,
        };
      case CREATE_NEWSTUDY_DATA_FAILURE:
        return {
          ...state,
          createStudy: null,
          error: action.payload,
        };
      case GET_AEPREVIEW_DATA_SUCCESS:
        return {
          ...state,
          allAEPreview: action.payload,
          error: null,
        };
      case GET_AEPREVIEW_DATA_FAILURE :
        return {
          ...state,
          data: null,
          error: action.payload,
        };
      case GET_ZONE_DATA_SUCCESS:
        return {
          ...state,
          data: action.payload,
          error: null,
        };
      case GET_ZONE_DATA_FAILURE:
        return {
          ...state,
          data: null,
          error: action.payload,
        };

        case GET_STATE_DATA_SUCCESS:
        return {
          ...state,
          stateData: action.payload,
          stateError: null,
        };

        case GET_STATE_DATA_FAILURE:
        return {
          ...state,
          stateData: null,
          stateError: action.payload,
        };

        case GET_CITY_DATA_SUCCESS:
        return {
          ...state,
          cityData: action.payload,
          cityError: null,
        };
        
        case GET_CITY_DATA_FAILURE:
        return {
          ...state,
          cityData: null,
          cityError: action.payload,
        };

        case GET_SITE_DATA_SUCCESS:
        return {
          ...state,
          siteData: action.payload,
          siteError: null,
        };
        case GET_SITE_DATA_FAILURE:
        return {
          ...state,
          siteData: null,
          siteError: action.payload,
        };

        case GET_STUDY_DATA_SUCCESS:
        return {
          ...state,
          studyData: action.payload,
          studyError: null,
        };
        case GET_STUDY_DATA_FAILURE:
        return {
          ...state,
          studyData: null,
          studyError: action.payload,
        };
        case GET_DOSE_ADMINISTRATION:
        return {
          ...state,
          doseAdministration: action.payload,
          doseAdministrationError: null,
        };
        case GET_DOSE_ADMINISTRATION_FAILURE:
        return {
          ...state,
          doseAdministration: null,
          doseAdministrationError: action.payload,
        };

        case GET_SITE_ADMINISTRATION:
        return {
          ...state,
          siteAdministration: action.payload,
          siteAdministrationError: null,
        };
        case GET_SITE_ADMINISTRATION_FAILURE:
        return {
          ...state,
          siteAdministration: null,
          siteAdministrationError: action.payload,
        };
        case GET_STUDIES_DATA_SUCCESS:
        return {
          ...state,
          getStudiesData: action.payload,
          getStudiesError: null,
        };
        case GET_STUDIES_DATA_FAILURE:
        return {
          ...state,
          getStudiesData: null,
          getStudiesError: action.payload,
        };
        case GET_AEBANK_DATA_SUCCESS:
        return {
          ...state,
          allAeEventsData: action.payload,
          allAeEventsError:null
        };
        case GET_AEBANK_DATA_FAILURE:
        return {
          ...state,
          allAeEventsData:null,
          allAeEventsError:action.payload
        }
        case GET_QR_STUDY_INFO:
        return {
          ...state,
          getQrStudy: action.payload,
          error: action.payload,
        };
      case GET_QR_STUDY_INFO_FAILURE:
        return {
          ...state,
          getQrStudy: null,
          error: action.payload,
        };
        case GET_MR_STUDY_INFO:
        return {
          ...state,
          getMrStudy: action.payload,
          error: action.payload,
        };
      case GET_MR_STUDY_INFO_FAILURE:
        return {
          ...state,
          getMrStudy: null,
          error: action.payload,
        };
       
        case GET_QR_STUDYLIST_DATA_SUCCESS:
        return {
          ...state,
          qrStudyList: action.payload,
          error: action.payload,
        };
      case GET_QR_STUDYLIST_DATA_FAILURE:
        return {
          ...state,
          qrStudyList: null,
          error: action.payload,
        };


        case GET_QRSUBJECTS_RELATED_COUNTS_SUCCESS:
        return {
          ...state,
          qrSubjectsRelatedcounts: action.payload,
          error: action.payload,
        };
      case GET_QRSUBJECTS_RELATED_COUNTS_FAILURE:
        return {
          ...state,
          qrSubjectsRelatedcounts: null,
          error: action.payload,
        };
        case GET_QRSUBJECT_COUNTS_SUCCESS:
        return {
          ...state,
          qrSubjectcounts: action.payload,
          error: action.payload,
        };
      case GET_QRSUBJECT_COUNTS_FAILURE:
        return {
          ...state,
          qrSubjeCtcounts: null,
          error: action.payload,
        };

        case GET_MSSUBJECT_DB_COUNTS_SUCCESS:
        return {
          ...state,
          msdbcounts: action.payload,
          error: action.payload,
        };
      case GET_MSSUBJECT_DB_COUNTS_FAILURE:
        return {
          ...state,
          msdbcounts: null,
          error: action.payload,
        };

        case GET_QRSUBJECT_LIST_SUCCESS:
          return {
            ...state,
            qrSubjectList: action.payload,
            error: null,
          };
        
        case GET_QRSUBJECT_LIST_FAILURE:
          return {
            ...state,
            qrSubjectList: null,
            error: action.payload,
          };
        case GET_QRSUBJECT_REVIEW_LIST_SUCCESS:
          return {
            ...state,
            qrSubjectReviewList: action.payload,
            error: null,
          };
        
        case GET_QRSUBJECT_REVIEW_LIST_FAILURE:
          return {
            ...state,
            qrSubjectReviewList: null,
            error: action.payload,
          };
        case GET_SUBJECT_INFORMATION_SUCCESS:
          return {
            ...state,
            qrSubjectInfoList: action.payload,
            error: null,
          };
        
        case GET_SUBJECT_INFORMATION_FAILURE:
          return {
            ...state,
            qrSubjectInfoList: null,
            error: action.payload,
          };

          case GET_MRSUBJECT_LIST_SUCCESS:
          return {
            ...state,
            mrSubjectList: action.payload,
            error: null,
          };
        
        case GET_MRSUBJECT_LIST_FAILURE:
          return {
            ...state,
            mrSubjectList: null,
            error: action.payload,
          };
          case GET_REVIEW_SUBJECT_DETAILS_SUCCESS:
          return {
            ...state,
            revSubjDtls: action.payload,
            error: null,
          };
        
        case GET_REVIEW_SUBJECT_DETAILS_FAILURE:
          return {
            ...state,
            revSubjDtls: null,
            error: action.payload,
          };

          case GET_MRSUBJECT_COUNTS_SUCCESS:
          return {
            ...state,
            mrSubjectcounts: action.payload,
            error: null,
          };
        
        case GET_MRSUBJECT_COUNTS_FAILURE:
          return {
            ...state,
            mrSubjectcounts: null,
            error: action.payload,
          };

          case GET_QRDASHBOARD_LIST_SUCCESS:
            return {
              ...state,
              qrDashboardList: action.payload,
              error: null,
            };
          
          case GET_QRDASHBOARD_LIST_FAILURE:
            return {
              ...state,
              qrDashboardList: null,
              error: action.payload,
            };

            case GET_ALL_MEDDRA_CLASSIFICATION_SUCCESS:
              return {
                ...state,
                medraList: action.payload,
                error: null,
              };
            
            case GET_ALL_MEDDRA_CLASSIFICATION_FAILURE:
              return {
                ...state,
                medraList: null,
                error: action.payload,
              };
            case GET_PI_REJ_SUBJECTS_SUCCESS:
              return {
                ...state,
                piRejSubj: action.payload,
                error: null,
              };
            
            case GET_PI_REJ_SUBJECTS_FAILURE:
              return {
                ...state,
                piRejSubj: null,
                error: action.payload,
              };
            case GET_REJ_SUBJ_DETAILS_SUCCESS:
              return {
                ...state,
                rejSubjDetls: action.payload,
                error: null,
              };
            
            case GET_REJ_SUBJ_DETAILS_FAILURE:
              return {
                ...state,
                rejSubjDetls: null,
                error: action.payload,
              };

              case GET_ALL_WHODD_CLASSIFICATION_SUCCESS:

              return {
                ...state,
                whoddList: action.payload,
                error: null,
              };
            
            case GET_ALL_WHODD_CLASSIFICATION_FAILURE:
              return {
                ...state,
                whoddList: null,
                error: action.payload,
              };

              case GET_ALL_WHODD_CLASSIFICATION_SUCCESS_1:

              return {
                ...state,
                whoddListNew: action.payload,
                error: null,
              };
            
            case GET_ALL_WHODD_CLASSIFICATION_FAILURE_1:
              return {
                ...state,
                whoddListNew: null,
                error: action.payload,
              };
         case GET_PMSSUBJECT_COUNTS_SUCCESS:
           return {
          ...state,
          pmsSubjectcounts: action.payload,
          error: action.payload,
          };
        case GET_PMSSUBJECT_COUNTS_FAILURE:
          return {
          ...state,
          pmsSubjeCtcounts: null,
          error: action.payload,
          };

              case GET_SITES_MH_DATA_SUCCESS:
                return {
                  ...state,
                  allMHsites: action.payload,
                  error: null,
                };
              case GET_SITES_MH_DATA_FAILURE :
                return {
                  ...state,
                  allMHsites: null,
                  error: action.payload,
                };
        
          
          case GET_PMSDASHBOARD_CHART_DATA__SUCCESS:
            return {
              ...state,
              pmsDashboardChartData: action.payload,
              error: null,
            };
          
          case GET_PMSDASHBOARD_CHART_DATA_FAILURE:
            return {
              ...state,
              pmsDashboardChartData: null,
              error: action.payload,
            }
            case GET_PMSSTUDY_DATA_SUCCESS:
              return {
                ...state,
                getPmsStudiesData: action.payload,
                getStudiesError: null,
              };
              case GET_PMSSTUDY_DATA_FAILURE:
              return {
                ...state,
                getPmsStudiesData: null,
                getStudiesError: action.payload,
              };

              case GET_PMS_STUDY_INFO:
                return {
                  ...state,
                  getPmsStudy: action.payload,
                  error: action.payload,
                };

                 case GET_PMSSUBJECT_LIST:
                  return {
                    ...state,
                    pmsSubjectList: action.payload,
                    error: null,
                  };
      
                  case GET_PMSSUBJECT_LIST_FAILURE:
                    return {
                      ...state,
                      pmsSubjectList: null,
                      error: action.payload,
                    };
                    case GET_PMSSUBJECTDASHBOARD_COUNTS_SUCCESS:
                      return {
                     ...state,
                     pmsSubjeCtDashboardcounts: action.payload,
                     error: action.payload,
                     };
                   case GET_PMSSUBJECTDASHBOARD_COUNTS_FAILURE:
                     return {
                     ...state,
                     pmsSubjeCtDashboardcounts: null,
                     error: action.payload,
                     };

                     case GET_PMS_REPORTS_DATA_SUCCESS:
                      return{
                        ...state,
                        pmsReportsChartData:action.payload,
                        error:action.payload
                      }
                      case GET_PMS_REPORTS_DATA_FAILTURE:
                        return{
                          ...state,
                          pmsReportsChartData:null,
                          error:action.payload
                        }
              
                        case GET_CHANGELOGGER_SUCCESS:
                          return{
                            ...state,
                            pmsChangeLoggerData:action.payload,
                            error:action.payload
                          }
                          case GET_CHANGELOGGER_FAILURE:
                            return{
                              ...state,
                              pmsChangeLoggerData:null,
                              error:action.payload
                            }
                            case GET_AUTDITLOGGER_SUCCESS:
                              return{
                                ...state,
                                pmsAuditLoggerData:action.payload,
                                error:action.payload
                              }
                              case GET_AUTDITLOGGER_FAILURE:
                                return{
                                  ...state,
                                  pmsAuditLoggerData:null,
                                  error:action.payload
                                }
                                case GET_CONCLUDED_DATA_SUCCESS:
                                  return{
                                    ...state,
                                    pmsConcludedData:action.payload,
                                    error:action.payload
                                  }
                                  case GET_CONCLUDED_DATA_FAILURE:
                                    return{
                                      ...state,
                                      pmsConcludedData:null,
                                      error:action.payload
                                    }
                  
                     case GET_PMSSUBJECT_DETAILS_SUCCESS:
                      return {
                        ...state,
                        subjPmsDtls: action.payload,
                        error: null,
                      };
                    
                    case GET_PMSSUBJECT_DETAILS_FAILURE:
                      return {
                        ...state,
                        subjPmsDtls: null,
                        error: action.payload,
                      }

                      case GET_PMSEVENTSUBJECT_LIST_SUCCESS:
                        return {
                          ...state,
                          eventPmsDtls: action.payload,
                          error: null,
                        };
                      
                      case GET_PMSEVENTSUBJECT_LIST_FAILURE:
                        return {
                          ...state,
                          eventPmsDtls: null,
                          error: action.payload,
                        }

                         case GET_PMSEVENT_COMMENTS_SUCCESS:
                        return {
                          ...state,
                          eventPmsComment: action.payload,
                          error: null,
                        };
                      
                      case GET_PMSEVENT_COMMENTS_FAILURE:
                        return {
                          ...state,
                          eventPmsComment: null,
                          error: action.payload,
                        }

                        case GET_PMSADVERSE_EVENTS_OF_SUBJECT_SUCCESS:
                          return {
                            ...state,
                            pmsAdverseEvent: action.payload,
                            error: null,
                          };
                        
                        case GET_PMSADVERSE_EVENTS_OF_SUBJECT_FAILURE:
                          return {
                            ...state,
                            pmsAdverseEvent: null,
                            error: action.payload,
                          }
                          case GET_NEWPMSSTUDY_DATA_SUCCESS:
                            return {
                              ...state,
                              getNewPmsStudiesData: action.payload,
                              getStudiesError: null,
                            };
                            case GET_NEWPMSSTUDY_DATA_FAILURE:
                            return {
                              ...state,
                              getNewPmsStudiesData: null,
                              getStudiesError: action.payload,
                            };
                          
      default:
        return state;
    }
  };
  
  export default ReduxReducer;